/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaParty: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="party" viewBox="0 0 43 42">
      <g clipPath="url(#clip0_1464:7804)">
        <path
          d="M12.8394 12.0565C12.2084 11.4254 11.1318 11.6561 10.8174 12.4945L0.377095 40.3352C0.00723895 41.3214 0.973098 42.2899 1.96119 41.9192C3.35949 41.3949 28.6799 31.8997 29.8018 31.479C30.6363 31.1662 30.8741 30.0912 30.2398 29.457L12.8394 12.0565ZM12.4505 15.1477L17.5066 20.2039C17.8565 24.4086 19.4142 28.4508 21.9541 31.7937L16.6907 33.7675C12.7538 29.6722 10.7446 23.9466 11.2798 18.2695L12.4505 15.1477ZM9.13315 36.6016C7.91941 35.223 6.90991 33.6867 6.1232 32.0204L9.09452 24.0967C9.83251 28.1496 11.6528 31.7751 14.2058 34.6992L9.13315 36.6016ZM4.97582 35.0801C5.49061 35.9309 6.06234 36.7447 6.68803 37.5185L3.63165 38.6647L4.97582 35.0801ZM24.3726 30.8868C22.5273 28.6417 21.2028 26.001 20.4922 23.1894L27.1486 29.8458L24.3726 30.8868Z"
          fill="#003349"
        ></path>
        <path
          d="M28.8855 22.9813C29.3661 23.4618 30.1451 23.4618 30.6256 22.9813C35.2545 18.3523 39.7617 19.7835 39.8068 19.7984C40.4514 20.0132 41.1482 19.6648 41.3631 19.0202C41.5781 18.3757 41.2296 17.6787 40.5849 17.4638C40.3423 17.383 34.578 15.5488 28.8856 21.2412C28.405 21.7217 28.405 22.5008 28.8855 22.9813Z"
          fill="#003349"
        ></path>
        <path
          d="M19.3152 13.4111C19.7956 13.8917 20.5747 13.8917 21.0552 13.4111C26.7476 7.71876 24.9134 1.95445 24.8326 1.71181C24.6177 1.06717 23.9208 0.718638 23.2763 0.933629C22.6316 1.14854 22.2833 1.84535 22.4981 2.49C22.5131 2.53503 23.9441 7.04229 19.3152 11.6712C18.8347 12.1516 18.8347 12.9307 19.3152 13.4111Z"
          fill="#003349"
        ></path>
        <path
          d="M23.6653 16.0208C23.1848 16.5014 23.1848 17.2804 23.6653 17.7609C24.1414 18.237 24.915 18.2433 25.398 17.7682C26.0337 17.4515 28.0066 18.6394 29.103 17.5433C30.1876 16.4586 29.0352 14.5258 29.3231 13.8485C30.0013 13.5599 31.9334 14.7128 33.018 13.6283C34.1029 12.5436 32.9504 10.6108 33.2383 9.93334C33.9175 9.64469 35.8485 10.7978 36.9331 9.71318C38.018 8.62847 36.8655 6.69568 37.1534 6.01823C37.8286 5.73105 39.7644 6.88155 40.8484 5.79799C41.9444 4.70187 40.7587 2.72545 41.0731 2.09311C41.5464 1.6121 41.5438 0.838514 41.0658 0.360382C40.5854 -0.120127 39.8063 -0.120127 39.3258 0.360382C38.356 1.33018 38.5457 2.69928 38.7284 3.6781C37.7495 3.49543 36.3805 3.3057 35.4107 4.27541C34.4409 5.24521 34.6307 6.61431 34.8133 7.59313C33.8345 7.41054 32.4653 7.22065 31.4956 8.19053C30.5258 9.16033 30.7156 10.5294 30.8983 11.5082C29.9193 11.3256 28.5503 11.1358 27.5806 12.1056C26.6108 13.0754 26.8005 14.4445 26.9832 15.4233C26.0043 15.2408 24.6349 15.051 23.6653 16.0208Z"
          fill="#003349"
        ></path>
        <path
          d="M30.6255 5.58087C31.1061 5.10036 31.1061 4.32136 30.6255 3.84085C30.145 3.36034 29.366 3.36034 28.8855 3.84085C28.405 4.32136 28.405 5.10036 28.8855 5.58087C29.366 6.06138 30.145 6.06138 30.6255 5.58087Z"
          fill="#003349"
        ></path>
        <path
          d="M38.4557 14.6415C39.1353 14.6415 39.6861 14.0906 39.6861 13.4111C39.6861 12.7315 39.1353 12.1807 38.4557 12.1807C37.7762 12.1807 37.2253 12.7315 37.2253 13.4111C37.2253 14.0906 37.7762 14.6415 38.4557 14.6415Z"
          fill="#003349"
        ></path>
        <path
          d="M35.8457 24.7207C35.3652 25.2012 35.3652 25.9803 35.8457 26.4608C36.3262 26.9413 37.1052 26.9413 37.5858 26.4608C38.0663 25.9803 38.0663 25.2012 37.5858 24.7207C37.1053 24.2402 36.3262 24.2402 35.8457 24.7207Z"
          fill="#003349"
        ></path>
        <path
          d="M18.4454 7.32013C18.9259 6.83962 18.9259 6.06062 18.4454 5.58011C17.9649 5.0996 17.1859 5.0996 16.7054 5.58011C16.2248 6.06054 16.2248 6.83962 16.7054 7.32013C17.1859 7.80064 17.9649 7.80064 18.4454 7.32013Z"
          fill="#003349"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1464:7804">
          <rect
            width="42"
            height="42"
            fill="white"
            transform="translate(0.296387)"
          ></rect>
        </clipPath>
      </defs>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaParty)
